
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class EditActionButtons extends Vue {
  @Prop({ default: false }) isEditing!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) inline!: boolean;
  @Prop({ default: null }) editRef!: any;

  // German defaults (overridable)
  @Prop({ default: "Bearbeiten" }) editLabel!: string;
  @Prop({ default: "Änderungen speichern" }) saveLabel!: string;
  @Prop({ default: "Änderungen verwerfen" }) cancelLabel!: string;
  @Prop({ default: false }) hideEditIcon!: boolean;

  handleEdit(): void {
    this.editRef?.onEdit?.();
    this.$emit("update:isEditing", true);
  }
  handleSave(): void {
    this.editRef?.onSave?.();
    this.$emit("update:isEditing", false);
  }
  handleCancel(): void {
    this.editRef?.onCancel?.();
    this.$emit("update:isEditing", false);
  }
}
